import DeliveryStatusIcon from "@redotech/redo-icons/truck-01.svg";
import { ArrayStringFilterOperator } from "@redotech/redo-model/views/advanced-filters/array-string-filter";
import { fgFilterEntries } from "@redotech/redo-model/views/fulfillment/fg-filter-catalog";
import { ArrayStringTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";
import { formatSentenceCase } from "@redotech/util/string";

const entry = fgFilterEntries.deliveryStatus;

export const DeliveryStatusFilter: ArrayStringTableFilter = {
  type: entry.type,
  itemLabel: "delivery status",
  itemLabelPlural: "delivery statuses",
  operators: [...entry.operators],
  data: {
    name: entry.name,
    type: entry.type,
    value: [],
    operator: ArrayStringFilterOperator.ANY_OF,
  },
  Icon: DeliveryStatusIcon,
  values: [...entry.staticValues],
  display: (status: string) => {
    return formatSentenceCase(status.replace(/_/g, " "));
  },
  dbSearch: false,
  displayName: entry.displayName,
};
